// src/segments/segments.ts
function appendTextSegment(segments, delta) {
  const last = segments[segments.length - 1];
  if (last && last.kind === "text") {
    const updated = {
      kind: "text",
      content: last.content + delta
    };
    return [...segments.slice(0, -1), updated];
  }
  return [...segments, { kind: "text", content: delta }];
}
function appendStepSegment(segments, step) {
  const existingIdx = segments.findIndex(
    (s) => s.kind === "step" && s.step.id === step.id
  );
  if (existingIdx >= 0) {
    const updated = [...segments];
    updated[existingIdx] = { kind: "step", step };
    return updated;
  }
  return [...segments, { kind: "step", step }];
}
function appendWidgetSegment(segments, widget, widgetIndex) {
  return [...segments, { kind: "widget", widget, widgetIndex }];
}
function reconstructSegments(message) {
  const segments = [];
  for (const step of message.steps) {
    if (step.status === "done" || step.status === "error") {
      segments.push({ kind: "step", step });
    }
  }
  if (message.content && message.content.length > 0) {
    segments.push({ kind: "text", content: message.content });
  }
  message.widgets.forEach((widget, widgetIndex) => {
    segments.push({ kind: "widget", widget, widgetIndex });
  });
  return segments;
}
function isAssistantMessage(message) {
  return message.role === "assistant";
}
export {
  appendStepSegment,
  appendTextSegment,
  appendWidgetSegment,
  isAssistantMessage,
  reconstructSegments
};
//# sourceMappingURL=index.js.map